export default __webpack_public_path__ + "static/media/gafri-shop-moskovyan.df5943ba.png";